<template>
  <div>
    <v-layout justify-space-between align-center class="to-hide">
      <v-flex xs6>
        <div class="mb-12">
          <div class="page-title mb-2">Requirement Form</div>

          <div class="txt-head font-weight-light black--text">
            แบบฟอร์มความต้องการเทคโนโลยี
          </div>
        </div>
      </v-flex>
      <v-flex xs6>
        <v-layout justify-end mb-4>
          <v-flex shrink mr-4> </v-flex>
          <v-flex shrink mr-4>
            <v-btn
              color="#e51610"
              outlined
              rounded
              depressed
              @click.native="print()"
              v-if="$route.query.preview"
            >
              <Iconify
                style="color: #e51610"
                icon="fluent:document-pdf-24-filled"
              ></Iconify>
              <span style="color: #e51610">Export PDF </span>
            </v-btn>
          </v-flex>
          <v-flex shrink>
            <v-btn color="#5CB844" rounded depressed dark @click="onExport()">
              <Iconify
                style="color: #fff"
                icon="ri:file-excel-2-fill"
              ></Iconify>
              <span style="color: #fff">Export Excel </span>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <!--PRINT HEADER-->
    <div
      class="to-show py-5"
      style="
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 14px;
        display: none;
        visibility: hidden;
        height: 0px;
        width: 750px;
      "
    >
      <div class="txt-head" style="text-align: center">
        แบบฟอร์มความต้องการเทคโนโลยี (Requirement Form)
      </div>
      <div class="small-text" style="text-align: right; width: 100%">
        เลขที่ : {{ form.doc_no }}
      </div>
    </div>

    <div class="d-flex flex-column gap-12 mb-6" id="pdf">
      <!--  GENERAL  -->
      <divcard>
        <div class="card-part">
          <div class="txt-head black--text mb-2 d-flex align-items-center">
            <ValidatorIcon
              v-if="!$route.query.preview"
              :is-correct="validate('one')"
            ></ValidatorIcon>
            <span class="theme-color-one">ส่วนที่ 1 : </span>
            ข้อมูลทั่วไป
          </div>

          <div>
            <!-- Form 1 #line1 -->
            <div class="flex-center gap-16">
              <div class="flex xs4">
                <div class="mb-1 black--text">คำนำหน้า</div>
                <div>{{ form.p1_title_name }}</div>
              </div>

              <div class="flex xs4">
                <div class="mb-1 black--text">ชื่อ</div>
                <div>{{ form.p1_first_name }}</div>
              </div>

              <div class="flex xs4">
                <div class="mb-1 black--text">นามสกุล</div>
                <div>{{ form.p1_last_name }}</div>
              </div>
            </div>

            <!-- Form 1 #line2 -->
            <div class="flex-center gap-16">
              <div class="flex xs4">
                <div class="mb-1 black--text">อายุ (ปี)</div>
                <div>{{ form.p1_age }}</div>
              </div>

              <div class="flex xs8">
                <div class="mb-1 black--text">หมายเลขบัตรประชาชน</div>
                <div>{{ form.p1_pid }}</div>
              </div>
            </div>

            <!-- Form 1 #line3 -->
            <div class="flex-center gap-16">
              <div class="flex xs12">
                <div class="mb-1 black--text">ที่อยู่/อาคาร/หมู่บ้าน</div>
                <div>{{ form.p1_addr }}</div>
              </div>
            </div>

            <!-- Form 1 #line4 -->
            <div class="flex-center gap-16">
              <div class="flex xs4">
                <div class="mb-1 black--text">จังหวัด</div>
                <div>{{ form.p1_addr_pid }}</div>
              </div>

              <div class="flex xs4">
                <div class="mb-1 black--text">เขต/อำเภอ</div>
                <div>{{ form.p1_addr_did }}</div>
              </div>

              <div class="flex xs4">
                <div class="mb-1 black--text">แขวง/ตำบล</div>
                <div>{{ form.p1_addr_sdid }}</div>
              </div>
            </div>

            <!-- Form 1 #line5 -->
            <div class="flex-center gap-16">
              <div class="flex xs4">
                <div class="mb-1 black--text">รหัสไปรษณีย์</div>
                <div>{{ form.p1_addr_postcode }}</div>
              </div>

              <div class="flex xs4">
                <div class="mb-1 black--text">โทรศัพท์</div>
                <div>{{ form.p1_phone }}</div>
              </div>

              <div class="flex xs4">
                <div class="mb-1 black--text">โทรศัพท์มือถือ</div>
                <div>{{ form.p1_mobile_phone }}</div>
              </div>
            </div>

            <!-- Form 1 #line6 -->
            <div class="flex-center gap-16">
              <div class="flex xs4">
                <div class="mb-1 black--text">โทรสาร</div>
                <div>{{ form.p1_fax }}</div>
              </div>

              <div class="flex xs4">
                <div class="mb-1 black--text">อีเมล</div>
                <div>{{ form.p1_email }}</div>
              </div>

              <div class="flex xs4">
                <div class="mb-1 black--text">เว็บไซต์</div>
                <div class="ellipsis-1-line d-block">
                  <tooltip-text :text="form.p1_website" />
                </div>
              </div>
            </div>

            <!-- Form 1 #line7 -->
            <div class="d-flex align-center gap-16">
              <div class="flex xs4">
                <div class="mb-1 black--text">ตำแหน่งในองค์กร</div>
                <div>{{ form.p1_position }}</div>
              </div>

              <div class="flex shrink flex-center gap-12">
                <div class="mb-1 black--text">
                  อำนาจในการตัดสินใจเข้าร่วมโครงการ
                </div>
                <div>{{ form.p1_authority ? "มี" : "ไม่มี" }}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="card-part">
          <div class="d-flex align-center gap-12">
            <div class="mb-1 txt-head black--text">ข้อมูลสถานประกอบการ</div>
            <div>
              {{
                form.p1_same_addr ? "ตั้งอยู่ที่เดียวกัน" : "ตั้งอยู่คนละที่"
              }}
            </div>
          </div>

          <!-- Form 2 -->
          <div v-if="!form.p1_same_addr">
            <!-- Form 2 #line1 -->
            <div class="flex-center gap-16">
              <div class="flex xs12">
                <div class="mb-1 black--text">ที่อยู่/อาคาร/หมู่บ้าน</div>
                <div>{{ form.p1_org_addr }}</div>
              </div>
            </div>

            <!-- Form 2 #line2 -->
            <div class="flex-center gap-16">
              <div class="flex xs4">
                <div class="mb-1 black--text">จังหวัด</div>
                <div>{{ form.p1_org_pid }}</div>
              </div>

              <div class="flex xs4">
                <div class="mb-1 black--text">เขต/อำเภอ</div>
                <div>{{ form.p1_org_did }}</div>
              </div>

              <div class="flex xs4">
                <div class="mb-1 black--text">แขวง/ตำบล</div>
                <div>{{ form.p1_org_sdid }}</div>
              </div>
            </div>

            <!-- Form 2 #line3 -->
            <div class="flex-center gap-16">
              <div class="flex xs4">
                <div class="mb-1 black--text">รหัสไปรษณีย์</div>
                <div>{{ form.p1_org_postcode }}</div>
              </div>

              <div class="flex xs4">
                <div class="mb-1 black--text">โทรศัพท์</div>
                <div>{{ form.p1_org_phone }}</div>
              </div>

              <div class="flex xs4">
                <div class="mb-1 black--text">โทรศัพท์มือถือ</div>
                <div>{{ form.p1_org_mobile_phone }}</div>
              </div>
            </div>

            <!-- Form 2 #line4 -->
            <div class="flex-center gap-16">
              <div class="flex xs4">
                <div class="mb-1 black--text">โทรสาร</div>
                <div>{{ form.p1_org_fax }}</div>
              </div>

              <div class="flex xs4">
                <div class="mb-1 black--text">อีเมล</div>
                <div>{{ form.p1_org_email }}</div>
              </div>

              <div class="flex xs4">
                <div class="mb-1 black--text">เว็บไซต์</div>
                <div class="ellipsis-1-line d-block">
                  <tooltip-text :text="form.p1_org_website" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card-part">
          <div class="txt-head black--text mb-3">สถานะ</div>
          <!-- Form 3 -->
          <div>
            <!-- Form 3 #line1 -->
            <div class="flex-center gap-16">
              <div class="flex">
                <div
                  v-html="
                    form.p1_personal_status
                      ? form.p1_personal_status.join(',<br>')
                      : '-'
                  "
                ></div>
              </div>
            </div>
          </div>
        </div>
      </divcard>

      <!--  BUSINESS  -->
      <divcard>
        <div class="txt-head black--text mb-2 d-flex align-items-center">
          <ValidatorIcon
            v-if="!$route.query.preview"
            :is-correct="true" 
          ></ValidatorIcon>
          <span class="theme-color-one">ส่วนที่ 2 :</span>
          ข้อมูลการประกอบการ/ศักยภาพความพร้อม
        </div>

        <!-- Form 1 -->
        <div>
          <!-- Form 1 #line1 -->
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                เลขทะเบียน นิติบุคคล/ทะเบียนการค้า (ถ้ามี)
              </div>
              <div>{{ form.p2_reg_no ?? "-" }}</div>
            </div>
          </div>

          <!-- Form 1 #line2 -->
          <div class="flex-center gap-16">
            <div class="flex xs6">
              <div class="mb-1 black--text">วิสาหกิจชุมชน (ถ้ามี)</div>
              <div>{{ form.p2_comm_ent ?? "-" }}</div>
            </div>

            <div class="flex xs6">
              <div class="mb-1 black--text">OTOP (ถ้ามี)</div>
              <div>{{ form.p2_otop ?? "-" }}</div>
            </div>
          </div>

          <!-- Form 1 #line3 -->
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">อื่น ๆ</div>
              <div>{{ form.p2_reg_other ?? "-" }}</div>
            </div>
          </div>
        </div>

        <div class="card-part">
          <div>
            <!-- Form 2 #line1 -->
            <div class="flex-center gap-16">
              <div class="flex xs6">
                <div class="mb-1 black--text">
                  ทุนจดทะเบียน/การระดมหุ้น (บาท)
                </div>
                <div>{{ form.p2_reg_cap ?? "-" }}</div>
              </div>

              <div class="flex xs6">
                <div class="mb-1 black--text">คนไทยถือหุ้นร้อยละ</div>
                <div>{{ form.p2_thai_share_pct ?? "-" }}</div>
              </div>
            </div>

            <!-- Form 2 #line2 -->
            <div class="flex-center gap-16">
              <div class="flex xs4">
                <div class="mb-1 black--text">ปีที่จดทะเบียน (พ.ศ.)</div>
                <div>{{ form.p2_reg_year ?? "-" }}</div>
              </div>

              <div class="flex xs4">
                <div class="mb-1 black--text">ปีที่ก่อตั้ง (พ.ศ.)</div>
                <div>{{ form.p2_est_year ?? "-" }}</div>
              </div>

              <div class="flex xs4">
                <div class="mb-1 black--text">จำนวนพนักงาน/สมาชิก (คน)</div>
                <div>{{ form.p2_emp_count ?? "-" }}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="card-part">
          <!-- Form 3 -->
          <div>
            <!-- Form 3 #line1 -->
            <div class="d-flex gap-16">
              <div class="flex xs4">
                <div class="mb-1 black--text">
                  การจดทะเบียนทรัพย์สินทางปัญญา
                </div>
              </div>

              <div>{{ form.p2_ip_status ? "" : "ยังไม่ได้ยื่นจดทะเบียน" }}</div>

              <div class="flex" v-if="form.p2_ip_status">
                <div class="d-flex justify-space-between gap-12">
                  <div class="flex xs6">
                    <div>{{ form.p2_ip_type }}</div>
                  </div>

                  <div class="flex xs6">
                    <div class="mb-2 black--text">เลขที่</div>
                    <div>{{ form.p2_ip_no }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card-part">
          <!-- Form 4 -->
          <div>
            <!-- Form 4 #line1 -->
            <div class="d-flex justify-space-between gap-16">
              <div class="flex xs4">
                <div>
                  {{
                    form.p2_has_prod === 0
                      ? "ยังไม่ได้ผลิตภันณฑ์ผลิตและจำหน่าย"
                      : form.p2_has_prod === 1
                      ? "มีผลิตภัณฑ์ผลิตและจำหน่ายแล้ว"
                      : "-"
                  }}
                </div>
              </div>

              <div class="flex">
                <div>{{ form.p2_prod_idea }}</div>
              </div>
            </div>

            <!-- Form 4 #line2 -->
            <div class="d-flex justify-space-between gap-16">
              <div class="flex xs4">
                <div>{{ form.p2_prod_name }}</div>
              </div>

              <div class="flex d-flex justify-space-between gap-12">
                <div class="flex xs6">
                  <div class="mb-1 black--text">มาตรฐานคุณภาพที่ได้รับ</div>
                  <div>{{ form.p2_prod_qc }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card-part">
          <div>
            <div class="mb-1 black--text">ผลงานที่ผ่านมา</div>
            <div>{{ form.p2_past_works }}</div>
          </div>
        </div>
      </divcard>

      <divcard>
        <div class="card-part">
          <div class="txt-head black--text mb-2 d-flex align-items-center">
            <ValidatorIcon
              v-if="!$route.query.preview"
              :is-correct="validate('three')"
            ></ValidatorIcon>
            <span class="theme-color-one">ส่วนที่ 3 :</span>
            ประเด็นปัญหาและความต้องการ
          </div>

          <!-- Form 1 -->
          <div class="checkbox-list mb-3">
            <div
              v-html="
                form.p3_issue_and_req
                  ? form.p3_issue_and_req.join(', <br>')
                  : '-'
              "
            ></div>
            <div v-if="isOtherReq">อื่นๆ ระบุ: {{ form.p3_req_other }}</div>
          </div>
        </div>

        <div class="card-part">
          <!-- Form 2 -->
          <div>
            <div class="d-flex align-center justify-space-between mb-3">
              <div class="black--text txt-head">ผู้กรอกข้อมูล</div>
            </div>
            <v-img eager height="150" :src="imageURL"></v-img>
          </div>
        </div>
      </divcard>
    </div>

    <!-- Action buttons -->
    <div class="d-flex justify-space-between to-hide">
      <Button theme="2" @onClick="$router.push({ name: 'RequirementList' })"
        >ยกเลิก</Button
      >

      <div class="flex-center" v-if="!this.isOIC">
        <Button theme="3" min-width="120px" @onClick="backForm(form.id)"
          >&lt; ย้อนกลับ</Button
        >
<!--        <Button theme="4" min-width="120px" @onClick="saveDraft"-->
<!--          >บันทึกฉบับร่าง</Button-->
<!--        >-->
        <Button
          :theme="
            // validate('one') && validate('two') && validate('three') ? '1' : '2'
            validate('one') && validate('three') ? '1' : '2'
          "
          min-width="120px"
          @onClick="submitForm"
          :disabled="
            // validate('one') && validate('two') && validate('three')
            validate('one') && validate('three')
              ? false
              : true
          "
          >ยื่นแบบฟอร์ม</Button
        >
      </div>
    </div>
  </div>
</template>

<script>
import Button from "../../components/input/Button";

// import FormGeneral from "./FormGeneral"
// import FormBusiness from "./FormBusiness"
// import FormIssuesAndNeeds from "./FormIssuesAndNeeds"
import { eventBus, validateEmail } from "../../plugins/global-funcs";
import { apiDomain } from "@/store/constants";
import ValidatorIcon from "../../components/ValidatorIcon";
import * as XLSX from "xlsx";
import moment from "moment";
import { mapState } from "vuex";

export default {
  name: "RequirementPreview",
  components: {
    Button,
    ValidatorIcon,
    // FormGeneral,
    // FormBusiness,
    // FormIssuesAndNeeds
  },
  data() {
    return {
      form: {},
      isOtherReq: false,
      imageURL: "",

      jsonExcel: [],
    };
  },
  computed: {
    ...mapState({
      isLoading: (state) => state.General.isLoading,
      userInfo: (state) => state.Auth.User,
      isOIC: (state) => state.Auth.User.user_type === "สป.อว.",
    }),
  },
  created() {
    this.retrieveForms();
  },
  methods: {
    backForm(id) {
      this.$router.push({ path: `/requirement-form/${id}` });
    },
    nextForm() {
      if (this.currentStep >= this.documentSteps.length) return;
      this.saveDraft();
      this.currentStep += 1;
      this.$vuetify.goTo("#app");
    },
    async saveDraft() {
      this.requestForm(this.currentStep);
      let payload = {
        ...this.formGeneral,
        ...this.formBusiness,
        ...this.formIssuesAndNeeds,
        doc_no: "123123", // require field
        doc_status: "draft", // require field
      };
      console.log("payload: ", payload);
      try {
        let res = await this.$apiFire("Requirement/saveRequirementForm", payload);
        console.log(res);
        if (res) {
          this.$router.push({ name: "RequirementList" });
        }
      } catch (error) {
        this.$store.commit('General/setModal', {
          title: 'Error',
          text: error.message,
          theme: "error",
          showCancel: false,
          buttonText: 'OK'
        })
        return
      }
    },
    requestForm(formStep) {
      switch (formStep) {
        case 1:
          eventBus.$emit("requirementFormGeneral");
          break;

        case 2:
          eventBus.$emit("requirementFormBusiness");
          break;

        case 3:
          eventBus.$emit("requirementFormIssuesAndNeeds");
          break;
      }
    },
    retrieveForms() {
      // General form
      this.getFormById();
      eventBus.$on("requirementFormGeneralSend", (form) => {
        this.formGeneral = form;
        // clear org data on same address case
        if (form.p1_same_addr) {
          this.formGeneral.p1_org_addr = undefined;
          this.formGeneral.p1_org_pid = undefined;
          this.formGeneral.p1_org_did = undefined;
          this.formGeneral.p1_org_sdid = undefined;
          this.formGeneral.p1_org_postcode = undefined;
          this.formGeneral.p1_org_phone = undefined;
          this.formGeneral.p1_org_mobile_phone = undefined;
          this.formGeneral.p1_org_fax = undefined;
          this.formGeneral.p1_org_email = undefined;
          this.formGeneral.p1_org_website = undefined;
        }
        console.log("req form page: ", this.formGeneral);
        // keep in storage
        this.$store.commit("Requirement/setGeneralForm", this.formGeneral);
      });

      // Business form
      eventBus.$on("requirementFormBusinessSend", (form) => {
        this.formBusiness = form;
        // keep in storage
        this.$store.commit("Requirement/setBusinessForm", this.formBusiness);
      });

      // IssuesAndNeeds form
      eventBus.$on("requirementFormIssuesAndNeedsSend", (form) => {
        this.formIssuesAndNeeds = form;
        // keep in storage
        this.$store.commit(
          "Requirement/setIssuesAndNeedsForm",
          this.formIssuesAndNeeds
        );
      });
    },
    async getFormById() {
      let res = await this.$apiFire("Requirement/getRequirementFormById", {
        id: this.$route.params.id,
      });
      console.log("getFormById response", res);
      if (res) {
        //p1_personal_status
        if (
          res.requirementForm.p1_personal_status &&
          typeof res.requirementForm.p1_personal_status === "string"
        ) {
          res.requirementForm.p1_personal_status = JSON.parse(
            res.requirementForm.p1_personal_status
          );
        }

        //p3_issue_and_req
        const needle = "อื่น ๆ";
        //convert string to json
        if (
          res.requirementForm.p3_issue_and_req &&
          typeof res.requirementForm.p3_issue_and_req === "string"
        ) {
          res.requirementForm.p3_issue_and_req = JSON.parse(
            res.requirementForm.p3_issue_and_req
          );
          console.log(res.requirementForm.p3_issue_and_req);
        }
        if (
          res.requirementForm.p3_issue_and_req &&
          res.requirementForm.p3_issue_and_req.includes(needle)
        ) {
          this.isOtherReq = true;
          const index = res.requirementForm.p3_issue_and_req.indexOf(needle);
          if (index > -1) {
            res.requirementForm.p3_issue_and_req.splice(index, 1);
          }
        }

        //p3_signature
        if (res.requirementForm.p3_signature) {
          this.imageURL =
            apiDomain + "storage/" + res.requirementForm.p3_signature;
          console.log(this.imageURL);
        }

        this.form = res.requirementForm;

        this.$forceUpdate();
      } else {
        this.$router.push({ name: "RequirementList" });
      }
    },
    validate(section) {
      let isCorrect = true;
      switch (section) {
        case "one":
          if (
            !this.form.p1_title_name ||
            !this.form.p1_first_name ||
            !this.form.p1_last_name ||
            !this.form.p1_personal_status ||
            !this.form.p1_age ||
            !this.form.p1_pid ||
            !this.form.p1_addr ||
            !this.form.p1_addr_pid ||
            !this.form.p1_addr_did ||
            !this.form.p1_addr_sdid ||
            !this.form.p1_addr_postcode ||
            !this.form.p1_mobile_phone ||
            !validateEmail(this.form.p1_email) ||
            !this.form.p1_position
          ) {
            isCorrect = false;
          }

          if (!this.form.p1_same_addr) {
            if (
              !this.form.p1_org_addr ||
              !this.form.p1_org_pid ||
              !this.form.p1_org_did ||
              !this.form.p1_org_sdid ||
              !this.form.p1_org_postcode ||
              !this.form.p1_org_phone ||
              !this.form.p1_org_mobile_phone ||
              !validateEmail(this.form.p1_org_email)
            ) {
              isCorrect = false;
            }
          }

          return isCorrect;

        // case "two":
        //   if (
        //     !this.form.p2_reg_cap ||
        //     !this.form.p2_thai_share_pct ||
        //     !this.form.p2_reg_year ||
        //     !this.form.p2_est_year ||
        //     !this.form.p2_emp_count
        //   ) {
        //     isCorrect = false;
        //   }
        //   if (
        //     this.form.p2_ip_status &&
        //     (!this.form.p2_ip_type || !this.form.p2_ip_no)
        //   ) {
        //     isCorrect = false;
        //   }
        //   if (
        //     this.form.p2_has_prod &&
        //     (!this.form.p2_prod_name || !this.form.p2_prod_qc)
        //   ) {
        //     isCorrect = false;
        //   }
        //   if (!this.form.p2_has_prod && !this.form.p2_prod_idea) {
        //     isCorrect = false;
        //   }

        //   return isCorrect;

        case "three":
          if (!this.form.p3_issue_and_req) {
            isCorrect = false;
          }
          if (this.isOtherReq && !this.form.p3_req_other) {
            isCorrect = false;
          }
          if (!this.form.p3_signature) {
            isCorrect = false;
          }
          return isCorrect;

        default:
          return isCorrect;
      }
    },
    submitForm() {
      if (
        this.validate("one") &&
        this.validate("two") &&
        this.validate("three")
      ) {
        this.$apiFire("Requirement/updateRequirementForm", {
          id: this.$route.params.id,
          doc_status: "Submitted",
        }).then((res) => {
          if (res) {
            this.$router.push({ name: "RequirementList" });
          }
        }).catch((error) => {
          this.$store.commit('General/setModal', {
            title: 'Error',
            text: error.message,
            theme: "error",
            showCancel: false,
            buttonText: 'OK'
          })
          return
        });
      }
    },

    onExport() {
      console.log(this.jsonExcel);
      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.json_to_sheet([]);

      // ส่วนหัวข้อ Requirement Form
      let doc_date = moment(this.form.doc_date)
        .add(543, "year")
        .format("DDMMYYYY");
      const topicRow = ["Requirement Form ", "ข้อมูล ณ วันที่ " + doc_date];
      XLSX.utils.sheet_add_aoa(worksheet, [topicRow], { origin: "A1" });

      // ส่วนที่ 1 : ข้อมูลทั่วไป
      const jsonExcelSection1 = [
        {
          "ชื่อ-นามสกุล":
            this.form.p1_title_name +
            " " +
            this.form.p1_first_name +
            " " +
            this.form.p1_last_name,
          "อายุ (ปี) ": this.form.p1_age,
          เลขประจำตัวประชาชน: this.form.p1_pid,
          "ที่อยู่/อาคาร/หมู่บ้าน": this.form.p1_addr,
          "แขวง/ตำบล": this.form.p1_addr_sdid,
          "เขต/อำเภอ": this.form.p1_addr_did,
          จังหวัด: this.form.p1_addr_pid,
          รหัสไปรษณีย์: this.form.p1_addr_postcode,
          โทรศัพท์: this.form.p1_phone,
          โทรศัพท์มือถือ: this.form.p1_mobile_phone,
          โทรสาร: this.form.p1_fax,
          อีเมล: this.form.p1_email,
          เว็บไซต์: this.form.p1_website,
          ตำแหน่งในองค์กร: this.form.p1_position,
          อำนาจในการตัดสินใจเข้าร่วมโครงการ: this.form.p1_authority
            ? "มี"
            : "ไม่มี",
          ข้อมูลสถานประกอบการ: this.form.p1_same_addr
            ? "ตั้งอยู่ที่เดียวกัน"
            : "ตั้งอยู่คนละที่",
          "ที่อยู่/อาคาร/หมู่บ้าน ":
            this.form.p1_same_addr == "ตั้งอยู่ที่เดียวกัน"
              ? this.form.p1_org_addr
              : this.form.p1_addr,
          "แขวง/ตำบล ":
            this.form.p1_same_addr == "ตั้งอยู่ที่เดียวกัน"
              ? this.form.p1_org_sdid
              : this.form.p1_addr_sdid,
          "เขต/อำเภอ ":
            this.form.p1_same_addr == "ตั้งอยู่ที่เดียวกัน"
              ? this.form.p1_org_did
              : this.form.p1_addr_did,
          "จังหวัด ":
            this.form.p1_same_addr == "ตั้งอยู่ที่เดียวกัน"
              ? this.form.p1_org_pid
              : this.form.p1_addr_pid,
          "รหัสไปรษณีย์ ":
            this.form.p1_same_addr == "ตั้งอยู่ที่เดียวกัน"
              ? this.form.p1_org_postcode
              : this.form.p1_addr_postcode,
          "โทรศัพท์ ":
            this.form.p1_same_addr == "ตั้งอยู่ที่เดียวกัน"
              ? this.form.p1_org_phone
              : this.form.p1_phone,
          "โทรศัพท์มือถือ ":
            this.form.p1_same_addr == "ตั้งอยู่ที่เดียวกัน"
              ? this.form.p1_org_mobile_phone
              : this.form.p1_mobile_phone,
          "โทรสาร ":
            this.form.p1_same_addr == "ตั้งอยู่ที่เดียวกัน"
              ? this.form.p1_org_fax
              : this.form.p1_fax,
          "อีเมล ":
            this.form.p1_same_addr == "ตั้งอยู่ที่เดียวกัน"
              ? this.form.p1_org_email
              : this.form.p1_email,
          "เว็บไซต์ ":
            this.form.p1_same_addr == "ตั้งอยู่ที่เดียวกัน"
              ? this.form.p1_org_website
              : this.form.p1_website,
          "สถานะ ": this.setArrToString(this.form.p1_personal_status),
        },
      ];
      // set หัวข้อ
      XLSX.utils.sheet_add_json(
        worksheet,
        [{ "ส่วนที่ 1 : ข้อมูลทั่วไป": "" }],
        {
          origin: "B2",
        }
      );
      XLSX.utils.sheet_add_json(worksheet, jsonExcelSection1, {
        origin: "C2",
      });

      // ส่วนที่ 2 : ข้อมูลการประกอบการ/ศักยภาพความพร้อม
      const jsonExcelSection2 = [
        {
          "เลขทะเบียน นิติบุคคล/ทะเบียนการค้า (ถ้ามี)": this.form.p2_reg_no,
          "วิสาหกิจชุมชน (ถ้ามี)": this.form.p2_comm_ent,
          "OTOP (ถ้ามี)": this.form.p2_otop,
          "อื่น ๆ โปรดระบุ": this.form.p2_reg_other,
          "ทุนจดทะเบียน/การระดมหุ้น (บาท)": this.form.p2_reg_cap,
          คนไทยถือหุ้นร้อยละ: this.form.p2_thai_share_pct,
          "ปีที่จดทะเบียน (พ.ศ.)": this.form.p2_reg_year,
          "ปีที่ก่อตั้ง (พ.ศ.)": this.form.p2_est_year,
          "จำนวนพนักงาน/สมาชิก (คน)": this.form.p2_emp_count,
          การจดทะเบียนทรัพย์สินทางปัญญา: this.form.p2_ip_status,
          ยังไม่ได้ผลิตภัณฑ์ผลิตและจำหน่าย:
            this.form.p2_has_prod === 0
              ? "ยังไม่ได้ผลิตภันณฑ์ผลิตและจำหน่าย"
              : this.form.p2_has_prod === 1
              ? "มีผลิตภัณฑ์ผลิตและจำหน่ายแล้ว"
              : "-",
          ผลงานที่ผ่านมา: this.form.p2_past_works,
        },
      ];
      // set หัวข้อ
      XLSX.utils.sheet_add_json(
        worksheet,
        [{ "ส่วนที่ 2 : ข้อมูลการประกอบการ/ศักยภาพความพร้อม": "" }],
        {
          origin: "AD2",
        }
      );
      XLSX.utils.sheet_add_json(worksheet, jsonExcelSection2, {
        origin: "AE2",
      });

      // ส่วนที่ 3 : ประเด็นปัญหาและความต้องการ
      let p3_issue_and_req = "";
      for (const [key, value] of Object.entries(this.form.p3_issue_and_req)) {
        p3_issue_and_req +=
          value +
          (parseInt(key) + 1 == this.form.p3_issue_and_req.length ? "" : "/");
      }
      // set หัวข้อ
      XLSX.utils.sheet_add_json(
        worksheet,
        [{ "ส่วนที่ 3 : ประเด็นปัญหาและความต้องการ": "" }],
        {
          origin: "AQ2",
        }
      );
      XLSX.utils.sheet_add_json(worksheet, [{ "": p3_issue_and_req }], {
        origin: "AR2",
        skipHeader: true,
      });

      let user = [
        {
          ชื่อผู้กรอกข้อมูล: this.form.user?.name,
        },
      ];
      XLSX.utils.sheet_add_json(worksheet, user, {
        origin: "AS2",
      });

      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet 1");
      let fileName = `Requirement_Form_${doc_date}.xlsx`;
      XLSX.writeFile(workbook, fileName);
    },

    setArrToString(val) {
      if (val.length == 0) {
        return "";
      }

      let str = "";
      val.forEach((element, i) => {
        str += element + (i == val.length - 1 ? "" : "/");
      });
      return str;
    },

    print() {
      //get current date dd-mm-yyyy
      let today = new Date();
      let dd = today.getDate();
      let mm = today.getMonth() + 1;
      let yyyy = today.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }
      today = dd + "-" + mm + "-" + yyyy;

      //change document title
      document.title =
        "Requirement_Form_" +
        this.doc_no +
        "_" +
        this.userInfo.user_type +
        "_" +
        today;
      let toHide = document.getElementsByClassName("to-hide");
      let pdfPage = document.getElementById("pdf");
      let mainContent = document.getElementById("main");
      let titled = document.getElementsByClassName("titled");
      let toShow = document.getElementsByClassName("to-show");
      let noBoxShadow = document.getElementsByClassName("theme-card");
      let s3p1 = document.getElementsByClassName("s3-p1");
      let s3p1h = document.getElementsByClassName("s3-p1-h");
      let indent_info = document.getElementsByClassName("indent-info");

      //remove all class name indent-info
      for (let i = 0; i < indent_info.length; i++) {
        indent_info[i].style.paddingLeft = "10px";
      }

      //show toShow
      for (let i = 0; i < toShow.length; i++) {
        toShow[i].style.display = "block";
        toShow[i].style.visibility = "visible";
        toShow[i].style.height = "auto";
      }

      //hide toHide
      for (let i = 0; i < toHide.length; i++) {
        toHide[i].style.display = "none";
        toHide[i].style.visibility = "hidden";
      }
      for (let i = 0; i < titled.length; i++) {
        titled[i].style.boxShadow = "none";

        //set box shadow to every child of titled
        let titledChild = titled[i].children;
        for (let j = 0; j < titledChild.length; j++) {
          titledChild[j].style.boxShadow = "none";
        }
      }

      //set no-box-shadow box-shadow to none
      for (let i = 0; i < noBoxShadow.length; i++) {
        noBoxShadow[i].style.boxShadow = "none";

        //set border
        noBoxShadow[i].style.border = "1px solid #F5F5F5";
      }

      //set s3p1 style scale 0.8
      for (let i = 0; i < s3p1.length; i++) {
        s3p1[i].style.transform = "scale(0.75)";
        s3p1[i].style.transformOrigin = "top left";
        s3p1[i].style.alignItems = "flex-start";

        //remove class overflow-x-auto
        s3p1[i].classList.remove("overflow-x-auto");
      }
      //set s3p1h style height
      for (let i = 0; i < s3p1h.length; i++) {
        s3p1h[i].style.height = "auto";
      }

      // pdfPage.style.minWidth = '600px'
      pdfPage.style.width = "750px";
      mainContent.style.paddingLeft = 0;
      mainContent.style.backgroundColor = "#fff";

      window.print();

      //reload
      window.location.reload();
    },
  },
};
</script>

<style scoped>
@page {
  size: A4 portrait;
  margin: 1mm 1mm 1mm 1mm;
}
</style>
